/**
 * Where agents connect. Shared by `/api` (ApiAccess) and the onboarding
 * agent step so the two never point at different servers.
 */

/** Public REST base, `/api/external/v1/`. */
export const EXTERNAL_API_BASE_URL =
  import.meta.env.VITE_PUBLIC_IS_PROD === "TRUE"
    ? "https://app.humblytics.com/api/external/v1/"
    : import.meta.env.VITE_PUBLIC_IS_LOCAL === "TRUE"
      ? "http://localhost:3000/api/external/v1/"
      : "https://humblytics.onrender.com/api/external/v1/"

/** API origin the MCP OAuth prompt calls (`/api/mcp/authorize`, `/api/mcp/poll`). */
export const API_ORIGIN = EXTERNAL_API_BASE_URL.replace("/api/external/v1/", "")

/** Hosted MCP server (Streamable HTTP). */
export const MCP_URL: string = import.meta.env.VITE_PUBLIC_MCP_URL || "https://mcp.humblytics.com/v1"
